import BovineList from '../../views/Bovine/BovineList';
import BovineEdit from '../../views/Bovine/BovineEdit';
import BovineImport from '../../views/Bovine/BovineImport';
import BovineSearchBar from '../../views/Bovine/components/BovineSearchBar';

export default [
    {
        path: '/bovinos',
        name: 'bovine.list',
        component: BovineList,
        meta: {
            pageTitle: 'Bovinos',
            searchBar: BovineSearchBar,
            breadcrumb: [
                {
                    label: 'Bovinos',
                },
            ],
        },
    },
    {
        path: '/bovinos/cadastro',
        name: 'bovine.create',
        component: BovineEdit,
        meta: {
            pageTitle: 'Cadastro de Bovino',
            breadcrumb: [
                {
                    label: 'Bovinos',
                    routeName: 'bovine.list',
                },
                {
                    label: 'Cadastro de Bovino',
                },
            ],
        },
    },
    {
        path: '/bovinos/:id',
        name: 'bovine.edit',
        component: BovineEdit,
        meta: {
            pageTitle: 'Edição de Bovino',
            breadcrumb: [
                {
                    label: 'Bovinos',
                    routeName: 'bovine.list',
                    routeParams: { cacheFilter: true }
                },
                {
                    label: 'Edição de Bovino',
                },
            ],
        },
    },
    {
        path: '/bovinos/importar',
        name: 'bovine.import',
        component: BovineImport,
        meta: {
            pageTitle: 'Importar Bovinos',
            breadcrumb: [
                {
                    label: 'Bovinos',
                    routeName: 'bovine.list',
                },
                {
                    label: 'Importar Bovinos',
                },
            ],
        },
    }
];
